import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {T2TemplateBasicComponent} from '../../trip2-theme/components/t2-template-basic/t2-template-basic.component';
import {UnprocessedClaimsComponent} from './unprocessed-claims/unprocessed-claims.component';
import {ProcessedClaimsComponent} from './processed-claims/processed-claims.component';
import {PaymentsComponent} from './payments/payments.component';
import {DenialsAuditsComponent} from './denials-audits/denials-audits.component';
import {DenialsComponent} from './denials/denials.component';

const routes: Routes = [
  { path: 'pages', component: T2TemplateBasicComponent,
    children: [
      { path: 'billingmodule/providers',
        children: [
          { path: 'unprocessedClaims', component: UnprocessedClaimsComponent, data: { title: 'Unprocessed Claims' } },
          { path: 'processedClaims', component: ProcessedClaimsComponent, data: { title: 'Processed Claims'} },
          { path: 'payments', component: PaymentsComponent, data: { title: 'Payments'} },
          { path: 'denialsAudits', component: DenialsAuditsComponent, data: { title: 'Denials / Audits'} },
          { path: 'providerDenials', component: DenialsComponent, data: { title: 'Provider Denials'} },
        ]
      }
    ]
  },
  { path: 'pages',
    children: [
      { path: 'providers',
        children: [
          { path: 'unprocessedClaims', component: UnprocessedClaimsComponent, data: { title: 'Unprocessed Claims' } },
          { path: 'processedClaims', component: ProcessedClaimsComponent, data: { title: 'Processed Claims'} },
          { path: 'payments', component: PaymentsComponent, data: { title: 'Payments'} },
          { path: 'denialsAudits', component: DenialsAuditsComponent, data: { title: 'Denials / Audits'} },
          { path: 'providerDenials', component: DenialsComponent, data: { title: 'Provider Denials'} },
        ]
      }
    ]
  }


];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class ProvidersBillingRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/pages/providers-billing/providers-billing-routing.module.ts